import { Pipe, PipeTransform } from '@angular/core';
import { format, isValid, parseISO } from 'date-fns';
import { enGB, nl } from 'date-fns/locale';
import { SupportedLanguagesCodes } from '@app/shared/enums/supported-language-codes.enum';
@Pipe({
  name: 'visitSlotDate'
})
export class VisitSlotDatePipe implements PipeTransform {

  transform(value: string, currentLangCode: string): string {
    const date = parseISO(value);
    if (!isValid(date)) {
      return '';
    }

    const locale = currentLangCode === SupportedLanguagesCodes.Dutch ? nl : enGB;

    let weekdayAbbrev = format(date, 'eee', { locale });
    weekdayAbbrev = weekdayAbbrev[0].toUpperCase() + weekdayAbbrev.slice(1);

    return weekdayAbbrev + format(date, ', dd MMM yyyy, H:mm');
  }

}
